import React, {useState} from "react"
import Blueprints from "./Blueprints"
import Map from "./Map"
import Switches from "./Switches"
import Briefcase from "./Briefcase"

function PartEight(props) {
    const [puzzleStatus, setPuzzleStatus] = useState({
        blueprints: false,
        map: false,
        switch: false,
        briefcase: false
    }) 
    const [currentPuzzle, setCurrentPuzzle] = useState(0)
    
    if (props.partStatus === "complete" && !puzzleStatus.blueprints) {
        setPuzzleStatus({
            blueprints: true,
            map: true,
            switch: true,
            briefcase: true
        })
    }
    
    function changePuzzleStatus(name, complete) {
        setPuzzleStatus({
            ...puzzleStatus,
            [name]: complete
        })
        setCurrentPuzzle(prevPuzzle => prevPuzzle + 1)
    }
    
    const puzzles = [
        <Blueprints callBackOverlay={props.callBackOverlay} callBackStatus={changePuzzleStatus} callBackRevealClues={props.callBackRevealClues} />,
        <Map callBackOverlay={props.callBackOverlay} callBackStatus={changePuzzleStatus} callBackRevealClues={props.callBackRevealClues} />,
        <Switches callBackOverlay={props.callBackOverlay} callBackStatus={changePuzzleStatus} callBackRevealClues={props.callBackRevealClues} />,
        <Briefcase callBackOverlay={props.callBackOverlay} callBackStatus={changePuzzleStatus} />
    ]
    
    const showPuzzle = puzzles[currentPuzzle]

    return (
        <div>
            {showPuzzle}
        </div>
    )
}

export default PartEight